<template>
    <div class="page-loader"></div>
</template>

<script>
    export default {
    }
</script>
